import { render, staticRenderFns } from "./sign_data.vue?vue&type=template&id=c1c8a86a&scoped=true"
import script from "./sign_data.vue?vue&type=script&lang=js"
export * from "./sign_data.vue?vue&type=script&lang=js"
import style0 from "./sign_data.vue?vue&type=style&index=0&id=c1c8a86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c8a86a",
  null
  
)

export default component.exports